import type { EmbeddedUser } from 'modules/core/types';
import { createEntityFilterChip } from './createEntityFilterChip';

export const UserFilterChip = createEntityFilterChip('auth/users/', {
  getOptionLabel: (u: EmbeddedUser) => u.email,
  getOptionValue: (u: EmbeddedUser) => u.id.toString(),
});
